import { useState } from 'react';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { protectFeature } from '~libs.shared.system';

import { practitionerSelectorStorage } from './PractitionerSelector.utils';

type UsePractitionerSelectorStateOutput = {
   setSelectedPractitioner: (practitioner: AppointmentPractitioner) => void;
   selectedPractitioner: AppointmentPractitioner;
};

export const usePractitionerSelectorState = (
   currentPractitionerId: number | undefined,
   practitioners: AppointmentPractitioner[]
): UsePractitionerSelectorStateOutput => {
   const [selectedPractitioner, setSelectedPractitioner] = useState<AppointmentPractitioner>(() => {
      const practitionerId = protectFeature(
         'searchingAllAppointments',
         practitionerSelectorStorage.getPractitionerId() ?? currentPractitionerId,
         currentPractitionerId
      );

      return practitioners.find((practitioner) => practitionerId === practitioner.id.asNumber()) ?? practitioners[0];
   });

   return {
      selectedPractitioner: selectedPractitioner,
      setSelectedPractitioner: (practitioner) => {
         setSelectedPractitioner(practitioner);
         practitionerSelectorStorage.setPractitionerId(practitioner.id);
      },
   };
};
